import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Crown } from "lucide-react";
import api from "../lib/api";
import VoteButton from "../components/VoteButton";
import RisingThisWeek from "../components/RisingThisWeek";

export default function Awards() {
  const [season, setSeason] = useState(null);
  const [board, setBoard] = useState([]);

  useEffect(() => {
    api.get("/awards/season").then((r) => setSeason(r.data)).catch(() => {});
    api.get("/awards/leaderboard?limit=25").then((r) => setBoard(r.data || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="awards-page" className="min-h-screen pt-32 pb-24">
      <section className="px-3 sm:px-6 md:px-10">
        <div className="relative max-w-6xl mx-auto rounded-2xl md:rounded-3xl overflow-hidden p-8 md:p-14 bg-gradient-to-br from-[#2a0a3d] via-[#6a0572] to-[#c29b00]">
          <div className="flex items-center gap-2 mb-3">
            <Crown className="w-6 h-6 text-yellow-300" />
            <div className="text-xs uppercase tracking-[0.3em] text-yellow-200 font-bold">{season?.name || "Creator Awards"}</div>
          </div>
          <h1 className="font-display font-black text-4xl sm:text-5xl md:text-6xl text-white tracking-tighter leading-[1.02]">
            ${season?.prize_pool_usd?.toLocaleString?.() || "50,000"}
            <br /><span className="text-yellow-200">in cash prizes.</span>
          </h1>
          <p className="mt-4 text-white/85 max-w-xl">
            Viewers decide. Cast one vote per video. The creators behind the most-loved content win share of the grand prize pool.
          </p>
          <div className="mt-5 flex flex-wrap gap-6 text-sm">
            <div><span className="text-white/60">Season runs</span><div className="text-white font-bold">{season?.start_date} → {season?.end_date}</div></div>
            <div><span className="text-white/60">Total votes cast</span><div className="text-white font-bold" data-testid="awards-total-votes">{(season?.total_votes ?? 0).toLocaleString()}</div></div>
            <div><span className="text-white/60">Unique voters</span><div className="text-white font-bold" data-testid="awards-voters">{(season?.unique_voters ?? 0).toLocaleString()}</div></div>
          </div>
        </div>
      </section>

      <RisingThisWeek />

      <section className="px-3 sm:px-6 md:px-10 mt-10 max-w-6xl mx-auto">
        <h2 className="font-display font-bold text-3xl text-white mb-5 flex items-center gap-2">
          <Trophy className="w-6 h-6 text-tv-accent" /> Current leaderboard
        </h2>
        {board.length === 0 ? (
          <div data-testid="awards-empty" className="text-white/60">No votes cast yet — be the first to nominate a creator.</div>
        ) : (
          <div className="space-y-3" data-testid="awards-leaderboard">
            {board.map((v, i) => (
              <div key={v.id} data-testid={`leaderboard-row-${v.id}`} className="tv-glass rounded-xl p-4 flex items-center gap-4">
                <div className={`font-display font-black text-3xl w-10 text-center ${i === 0 ? "text-tv-accent" : i < 3 ? "text-tv-brand" : "text-white/40"}`}>
                  #{i + 1}
                </div>
                <Link to={`/watch/${v.id}`} className="shrink-0">
                  <img src={v.thumbnail_url} alt="" className="w-28 h-16 object-cover rounded" />
                </Link>
                <div className="flex-1 min-w-0">
                  <Link to={`/watch/${v.id}`} className="block text-white font-display font-bold text-lg truncate hover:text-tv-brand">{v.title}</Link>
                  <div className="text-xs text-white/50 truncate">{v.creator_name} · {v.category}</div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-display font-black text-tv-accent">{v.vote_count}</div>
                  <div className="text-[10px] uppercase tracking-wider text-white/50">votes</div>
                </div>
                <VoteButton videoId={v.id} />
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
